import { render } from "./call-history-search.vue?vue&type=template&id=22c678de&scoped=true&ts=true"
import script from "./call-history-search.vue?vue&type=script&lang=ts"
export * from "./call-history-search.vue?vue&type=script&lang=ts"

import "./call-history-search.vue?vue&type=style&index=0&id=22c678de&scoped=true&lang=less"

import exportComponent from "/opt/jenkins/workspace/WF-cloud-admin-beta/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22c678de"]])

export default __exports__